import React, { useRef} from "react";
import styled from "styled-components";
import Cookies from 'js-cookie';
import {device} from "../../assets/styles/media.js";
import chk_on from '../../assets/images/icon_chk_on.png';


const Wrap = styled.div`
    top: 100px;
    width: 400px;
    height: 550px;
    z-index: 500;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 20px;

    ${device.tablet} {
        position: absolute;
        width: 80%;
        left: 50%;
        height: 900px;
        transform: translateX(-50%);
        top: 100px;
    }

    ${device.mobile} {
        position: absolute;
        left: 50%;
        height: 650px;
        transform: translateX(-50%);
        width: 90%;
    }
`;
const Contents = styled.div`
    width: 100%;
    overflow: hidden;
    cursor: ${({detail}) => detail ? "pointer" : "default"};
    img {
        width: 100%;
        height: 500px;
        display: block;
    }

    ${device.tablet} {
        img {
            height: 850px;
         
        }
    }
    ${device.mobile} {
        img {
            height: 400px;

        }
    }

`;
const BottomBar = styled.div`
    background-color: #000;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0 0 20px 20px;
    
    ${device.mobile} {
        padding: 10px 12px;
    }
`;

const DismissForToday = styled.button`
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    ${device.mobile} {
        bottom: 0;
    }
`;
const CheckBox = styled.input`
    display: none;
`;

const Label = styled.label`
    color: #fff;
    //cursor: pointer;
    font-size: 16px;
    line-height: 22px;
    &::before {
        content: "";
        display: inline-block;
        background-color: #d8d8d8;
        width: 22px;
        height: 22px;
        vertical-align: middle;
        cursor: pointer;
        margin-right: 7px;
        border-radius: 50%;
    }
    input:checked + &::before {
        background: url(${chk_on}) no-repeat center center;
        background-size: cover;
    }
`;
const Close = styled.button`
    width: 30px;
    height: 30px;
    cursor: pointer;

    &::before,
    &::after {
        content: '';
        position: absolute;
        width: 20px;
        height: 2px;
        background-color: #f3eeee;
        transform-origin: center;
    }

    &::before {
        transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
        transform: translate(-50%, -50%) rotate(-45deg);
    }
`;

const Popup = ({pop, setClosedPopups,setPopCnt}) => {
    const popRef = useRef(null);
    const closePopup  = () => {
        setPopCnt((prev)=> prev -1);
        if (popRef.current) {
            const {id} = popRef.current;
            const checkbox = popRef.current.querySelector('input[type="checkbox"]');
            const isChecked = checkbox?.checked;
            if (isChecked) {
                Cookies.set(`pop-${id}`, 'hidden', { expires: 1 });
            }
            popRef.current.style.display = "none";
            setClosedPopups((prev) => [...prev, id]);
        }
    };
    const checkLink = ( link ) => {
        if (!link.startsWith("http://") && !link.startsWith("https://")) {
            return "https://" + link;
        }
        return link;
    };


    return (
        <Wrap id={pop.idx} ref={popRef}>
            <Contents
                detail={pop.hyperlink}
                onClick={pop.hyperlink && (() => window.open(checkLink(pop.hyperlink)))}
            >
                <img src={pop.content} alt={pop.title}/>
            </Contents>
            <BottomBar>
                <DismissForToday>
                    <CheckBox
                        type="checkbox"
                        id={`pop-${pop.idx}`}
                        // onChange={(e) => {(e)}}
                    />
                    <Label htmlFor={`pop-${pop.idx}`} >오늘 하루 보지 않기</Label>
                </DismissForToday>
                <Close onClick={(e)=>closePopup(e)}/>
            </BottomBar>
        </Wrap>
    )
}
export default Popup;